import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { Option } from '../../interfaces/ProyectosDTOS/Option';

interface Props {
    onResponse?: (selectedValue: Option) => void;
    mensaje?: string,
    fillOptions: (searchTerm: string) => Promise<Option[]>;
}
  
export const AdaptiveSelect: React.FC<Props> = ({fillOptions,onResponse,mensaje }) => {
    const [selectedOption, setSelectedOption] = React.useState<Option | null>(null);
    const [searchTerm, setSearchTerm] = React.useState<string>('');
    const [option,setOptions] = React.useState<Option[]>([]);

  const handleChange = (selectedOption: Option | null) => {
    setSelectedOption(selectedOption);
    if (onResponse && selectedOption) {
      onResponse(selectedOption);
    }
  };

  const handleInputChange = (newValue: string) => {
    setSearchTerm(newValue);
    if (newValue.length >= 3) {
      fillOptions(newValue).then((options) => {
        //console.log(options);
        setOptions(options);
      });
    }
  };

  return (
    <div className='app-adaptativeSelect'>
      {/* <h2>{titulo}:</h2> */}
      <Select
        placeholder={mensaje??"Escriba al menos 3 caracteres"}
        options={option}
        value={selectedOption}
        onChange={handleChange}        
        onInputChange={handleInputChange} // Llama a handleInputChange cuando se cambia el valor del input
        inputValue={searchTerm} // Proporciona el valor del input al componente Select
      />
      {/* <div>Selected Option: {selectedOption ? selectedOption.label : 'None'}</div>
      <div>Selected Value: {selectedOption ? selectedOption.value : 0}</div> */}
    </div>
  );
  };